"use client";

import type * as React from "react";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

/**
 * App-wide toast host. Colours come from the app's own CSS variables rather
 * than sonner's `theme` prop, so toasts follow the `.dark` class the theme
 * provider sets without this package depending on the theme provider.
 */
function Toaster({ className, style, ...props }: ToasterProps) {
	return (
		<SonnerToaster
			className={className ?? "toaster group"}
			position="bottom-right"
			style={
				{
					"--border-radius": "var(--radius)",
					"--error-bg": "var(--destructive)",
					"--error-border": "var(--destructive)",
					"--error-text": "var(--destructive-foreground, white)",
					"--normal-bg": "var(--popover)",
					"--normal-border": "var(--border)",
					"--normal-text": "var(--popover-foreground)",
					...style,
				} as React.CSSProperties
			}
			{...props}
		/>
	);
}

export { Toaster, type ToasterProps };
export { toast } from "sonner";
